import { type INotificationResource, UNREAD_NOTIFICATION_STATUSES } from "@sol/sdk";

export const isNotificationUnread = ({ status }: Pick<INotificationResource, "status">) =>
    UNREAD_NOTIFICATION_STATUSES.includes(status);
